import React, {useContext} from "react";
import {LabelContext} from "../../assets/js/labelDataContext";
import DietDays from "../../assets/js/dietDays";

const OrderDay = (props) => {
    const val = useContext(LabelContext);
    const dietDay = val.labelInfo.dietDay;
    const diet = val.labelInfo.diet;
    const btnDisabled = dietDay.length > 0
    return (

        <form>

            <div className="diet-box">
                <h4>Wybierz wariant posiłków</h4>

                {DietDays.map((option, index) => {
                        return (
                            index == 1 ?
                                diet == 0 || diet == 1 || diet == 2 ?
                                    <div key={index}>
                                        <input
                                            id={`option-${index}`}
                                            type="radio"
                                            name="dietDay"
                                            value={index}
                                            onChange={val.handleChange("dietDay")}
                                        >
                                        </input>
                                        <label
                                            className={`diet-option ${dietDay == index ? "is-active" : ""}`}
                                            htmlFor={`option-${index}`}
                                        >
                                            {option.name}
                                        </label>
                                    </div>
                                    :
                                    <span></span>
                                :
                                <div key={index}>
                                    <input
                                        id={`option-${index}`}
                                        type="radio"
                                        name="dietDay"
                                        value={index}
                                        onChange={val.handleChange("dietDay")}
                                    >
                                    </input>
                                    <label
                                        className={`diet-option ${dietDay == index ? "is-active" : ""}`}
                                        htmlFor={`option-${index}`}
                                    >
                                        {option.name}
                                    </label>
                                </div>
                        )
                    }
                )}


                <div
                    variant="contained"
                    color="primary"
                    aria-label="text primary button group"
                    style={{marginTop: 15}}
                >
                    <button onClick={() => val.prevPage()}
                            className="btn-next">
                        Wstecz
                    </button>
                    <button
                        disabled={!btnDisabled}
                        onClick={() => val.nextPage()}
                        className="btn-next"
                    >
                        Dalej
                    </button>
                </div>
            </div>
        </form>
    );
};

export default OrderDay;
